/**
 * CustomerTemplates — the customer "Templates" browse/search/sync tab (spec 017 Feature C /
 * US4). A READ-ONLY catalog: the customer filters the shared template library, opens a
 * preview, and syncs a chosen template onto THIS device. A4 (owner, 2026-09-26): a customer
 * creates templates from Generate only, so this page has no creation entry and no wizard.
 *
 * The implementation is `TemplateListPage`'s `CustomerTemplatesSurface`; "read-only" is
 * `capabilitiesFor("customer", isAdmin)`, so every admin affordance is structurally absent.
 */
import { CustomerTemplatesSurface } from "./TemplateListPage.js";
import "./customer-templates.css";

export function CustomerTemplates({
  onGoExport,
}: {
  /** Route to the Export workspace. WS-B B-9: the optional tab is which sub-tab the handoff
   *  needs — "Create Mock-up" stages a real selection, and Batch is the tab that can act on it. */
  onGoExport: (tab?: "select" | "batch") => void;
}) {
  return <CustomerTemplatesSurface onGoExport={onGoExport} />;
}
